<template>
  <div class="dp_flex">
    <sui-select-box
      v-model="selectedBizCode1"
      :option-list="bizCode1List"
      :placeholder="''"
      :disabled="disabled"
      @list-click="onSelectBizCode1"
    />
    <div class="comp_spacing"></div>
    <sui-select-box
      v-model="selectedBizCode2"
      :option-list="bizCode2List"
      :placeholder="''"
      :disabled="disabled"
      @list-click="onSelectBizCode2"
    />
    <div class="comp_spacing"></div>
    <sui-select-box
      v-model="selectedBizCode3"
      :option-list="bizCode3List"
      :placeholder="''"
      :disabled="disabled"
      @list-click="onSelectBizCode3"
    />
  </div>
</template>

<script>

export default {
  name: 'CmpBizCodeSelect',
  props: {
    // 이 컴포넌트를 사용하는 페이지ID, 데이터서비스 호출시 사용
    pageId: {
      type: String,
      required: true,
    },
    // select disabled 제어
    disabled: {
      type: Boolean,
      required: false,
      default(){
        return false;
      }
    },
  },
  watch: {
  },
  data() {
    return {
      // 업무코드 첫번째 level select에서 선택된 값
      selectedBizCode1: {
        key: '',
        label: ''
      },
      // 업무코드 2번째 level select에서 선택된 값
      selectedBizCode2: {
        key: '',
        label: ''
      },
      // 업무코드 3번째 level select에서 선택된 값
      selectedBizCode3: {
        key: '',
        label: ''
      },
      // 업무코드 select 3개에 바인딩되는 배열
      bizCode1List: [],
      bizCode2List: [],
      bizCode3List: [],
    };
  },
  computed: {
  },
  mounted() {
    this.reset();
  },
  beforeDestroy() {
  },
  methods: {
    reset() {
      // 첫번째 레벨 업무코드 목록 셋팅
      this.getFirstLevelBizCodeList().then( (bizCode1List)=>{
        this.clearSelectData(1);
        this.setSelectData(1, bizCode1List);
      });
    },

    /**
     * 1level 업무코드 select의 selected object 반환
     * @function get1levelBizCode
     * @returns {Object} {key:'key1', label:'label1'}
     */
    get1levelBizCode(){
      return this.selectedBizCode1;
    },
    /**
     *  2level 업무코드 select의 selected object 반환
     * @function get2levelBizCode
     * @returns {Object} {key:'key1', label:'label1'}
     */
    get2levelBizCode(){
      return this.selectedBizCode2;
    },
    /**
     *  3level 업무코드 select의 selected object 반환
     * @function get3levelBizCode
     * @returns {Object} {key:'key1', label:'label1'}
     */
    get3levelBizCode(){
      return this.selectedBizCode3;
    },

    /**
     * 첫번째 업무코드 select의 select 이벤트 핸들러
     * 두번째 level 업무코드 목록을 조회해서 바인딩되는 배열을 셋팅
     * 자동셋팅에 사용하기 위해서 Promise를 리턴한다.
     * @function onSelectBizCode1
     * @param {Object} selectedCode : 1 level select 에서 선택된 업무코드
     * @returns {Promise}
     */
    onSelectBizCode1( selectedCode){

      if( utils.isEmpty( selectedCode)){
        return false;
      }

      this.getSubLevelBizCodeList(selectedCode).then( bizCodeList => {
        this.clearSelectData(2);            // 2 level select clear
        this.setSelectData(2, bizCodeList); // 2 level select list binding
        this.onSelectBizCode3();
      }).catch( (err)=> {
        utils.error(err.message);
      });
    },
    /**
     * 두번째 업무코드 select의 select 이벤트 핸들러
     * 세번째 level 업무코드 목록을 조회해서 바인딩되는 배열을 셋팅
     * 자동셋팅에 사용하기 위해서 Promise를 리턴한다.
     * @function onSelectBizCode2
     * @param {Object} selectedCode : 2 level select 에서 선택된 업무코드
     * @returns {Promise}
     */
    onSelectBizCode2( selectedCode){
      if( utils.isEmpty( selectedCode)){
        return false;
      }

      this.getSubLevelBizCodeList(selectedCode).then( bizCodeList => {
        this.clearSelectData(3);            // 3 level select clear
        this.setSelectData(3, bizCodeList); // 3 level select list binding
        this.onSelectBizCode3();
      }).catch( (err)=> {
        utils.error(err.message);
      });
    },
    /**
     * 세번째 업무코드 select의 select 이벤트 핸들러
     * changeBizCodes 이벤트를 emit하고 선택된 3개의 업무코드 값을 넘긴다.
     * @function onSelectBizCode3
     * @returns {None}
     */
    onSelectBizCode3(){
      let _arr = [];
      _arr.push(this.selectedBizCode1);
      _arr.push(this.selectedBizCode2);
      _arr.push(this.selectedBizCode3);
      this.$emit('select-changed', _arr);
    },

    /**
     * 업무코드 select 에 바인딩된 데이터를 clear 한다.
     * @function clearSelectData
     * @param {Number} bizCodeLevel : 1 or 2 or 3
     * @returns {None}
     */
    clearSelectData(bizCodeLevel){
      this.selectedBizCode3 = { key: "", label: ""};
      this.bizCode3List = [];

      switch( bizCodeLevel){
        case 1:
          this.selectedBizCode1 = { key: "", label: ""};
          this.bizCode1List = [];
        case 2:
          this.selectedBizCode2 = { key: "", label: ""};
          this.bizCode2List = [];
          break;
      }
    },
    /**
     * 업무코드 select 중 하나에 데이터를 바인딩한다.
     * @function setSelectData
     * @param {Number} bizCodeLevel : 1 or 2 or 3
     * @param {Array} arrBizCode : 데이터 서비스 결과 Array
     * @returns {None}
     */
    setSelectData(bizCodeLevel, arrBizCode){
      let curBizCodeList = "";
      switch( bizCodeLevel){
        case 1:
          curBizCodeList = this.bizCode1List;
          break;
        case 2:
          curBizCodeList = this.bizCode2List;
          break;
        case 3:
          curBizCodeList = this.bizCode3List;
          break;
      }

      arrBizCode.forEach( itm => {
        curBizCodeList.push({
          key: itm.codeValidityValue,
          label: itm.multiLanguageContent
        });
      });
    },

    /**
     * 첫번째 level의 업무코드 목록을 조회결과를 반환한다.
     * @function getFirstLevelBizCodeList
     * @returns {Promise}
     */
    getFirstLevelBizCodeList(){

      let that = this;
      return new Promise( ( resolve, reject)=>{
        http.request( that.pageId, 'DTS_CMZ_00055', {
        }).then(res => {
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });      
      });
    },
    /**
     * 
     */
    getSubLevelBizCodeList( selectedCode){

      if( utils.isEmpty( selectedCode)){
        return false;
      }

      var that = this;

      return new Promise( ( resolve, reject )=>{
        http.request( that.pageId, 'DTS_CMZ_00056', {
          query: {
            'codeValidityValue' : selectedCode.key
          },
        }).then(res => {
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });      
      });
    },

    /**
     * 3번째 level의 업무코드유효값(cd_vld_val)을 받아서 level1, level2 값을 가져온다.
     * @function getBizCodeUpToFirstLevel
     * @param String
     * @returns 
     */
    getBizCodeUpToFirstLevel( cdVldVal){

      if( utils.isEmpty( cdVldVal)){
        return false;
      }

      var that = this;

      return new Promise( ( resolve, reject)=>{
        http.request( that.pageId, 'DTS_CMZ_00057', {
          query: {
            'codeValidityValue' : cdVldVal
          },
        }).then(res => {
          resolve( res.data);
        }).catch(err => {
          reject( err);
        });      
      });
    },

    /**
     * 3번째 level의 업무코드유효값(cd_vld_val)을 받아서 업무코드 select 1,2,3 를 셋팅한다.
     * step1 - 상위 1,2번째 level의 업무코드를 가져온다.
     * step2 - 1레벨 업무코드 목록, step1에서 가져온 1레벨 업무코드를 기준으로 2레벨 업무코드목록, 
     *         step1에서 가져온 2레벨 업무코드 목록을 가져와서 각각의 업무코드 select를 구성하고 selected까지 설정한다.
     * @function setBizCodeSelects
     * @param {String} cdVldVal3rd : 3level 업무코드
     * @returns {none}
     */
    setBizCodeSelects( cdVldVal3rd){
      let _parentsCodeList = [];

      // step1: 상위 1,2번째 level의 업무코드 목록 가져옴
      this.getBizCodeUpToFirstLevel( cdVldVal3rd)
      .then( ( resList) => {
        // 1,2 level 업무코드 정보를 배열에 저장
        _parentsCodeList = resList;
        // 1 level 업무코드 목록 가져오기
        return this.getFirstLevelBizCodeList();
      })
      .then( (bizCode1List)=>{
        this.clearSelectData(1);
        this.setSelectData(1, bizCode1List);
        // 1 level select의 selected 셋팅
        let _seletedObj = utils.find( bizCode1List, { 'codeValidityValue': _parentsCodeList[0].codeValidityValue});
        this.selectedBizCode1 = {
          key: _seletedObj.codeValidityValue,
          label: _seletedObj.multiLanguageContent
        }

        // 2 level 업무코드 목록 가져옴
        return this.getSubLevelBizCodeList(this.selectedBizCode1);
      })
      .then( (bizCode2List)=>{
        this.setSelectData(2, bizCode2List);
        // 2 level select의 selected 셋팅
        let _seletedObj = utils.find( bizCode2List, { 'codeValidityValue': _parentsCodeList[1].codeValidityValue});
        this.selectedBizCode2 = {
          key: _seletedObj.codeValidityValue,
          label: _seletedObj.multiLanguageContent
        }

        // 3 level 업무코드 목록 가져옴
        return this.getSubLevelBizCodeList(this.selectedBizCode2);
      })
      .then( (bizCode3List)=>{
        this.setSelectData(3, bizCode3List);
        // 3 level select의 selected 셋팅
        let _seletedObj = utils.find( bizCode3List, { 'codeValidityValue': cdVldVal3rd});
        this.selectedBizCode3 = {
          key: _seletedObj.codeValidityValue,
          label: _seletedObj.multiLanguageContent
        }
      })
      .catch( (err)=>{
        utils.error(err.message);
      });
    },

  },
};
</script>

<style scoped>
</style>
